import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64668aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "store-link",
  href: "https://apple.co/3gLJDFa",
  target: "_blank",
  rel: "noreferrer"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.link,
      alt: "store link"
    }, null, 8, _hoisted_2)
  ]))
}